import React from 'react';
import $ from 'jquery';
import {MWBaseURL, Handle403, GetESTDateString} from './../Utilities.js'

class TagSearchTbl extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			auth: props.auth,
			acct: props.acct,
			
			date: props.date,
			dateEnd: props.dateEnd,
			tag: props.tag
		};

		this.table = null
	}

	static getDerivedStateFromProps(props, state) {
		if(props.tag !== state.tag || props.date !== state.date || props.dateEnd !== state.dateEnd){
			return {...props, needToUpdate: true}
		}
		return {...props};
	}

	componentDidUpdate(props, state){
		let self = this
		if(self.state.needToUpdate){
			self.setState({needToUpdate: false}, function(){
				self.table.ajax.reload()
			})
		}
	}
	
	componentDidMount() {
		let self = this
		this.table = $('#tagSearchTbl').DataTable({
			searching: false,
			scrollY: "300px",
			scrollX: true,
			responsive: true,
			paging: false,
			info: false,
			filter: true,
			ajax: {
				url: MWBaseURL()+"tag_search",
				data: {
					user: () => self.state.auth.user,
					token: () => self.state.auth.token,
					tagAndMode: false,
					acct: () => self.state.acct.join(","),
					tag: () => self.state.tag,
					date: () => self.state.date ?? '2012-01-01',
					dateEnd: () => self.state.dateEnd ?? GetESTDateString()
				},
				dataSrc: '',
				error: function (xhr, error, code){
					if(xhr.status === 403){
						Handle403(self.state)
					}
				}
			},
			columns: [
				{title: "Date", data: "fdate"},
				{title: "Symbol", data: "symbol"},
				{title: "Start",  data: "start"},
				{title: "End", data: "end"},
				{title: "Tags", data: "tag"},
				{title: "Notes", data: "notes"}
			]
		});
	}
	
	render(){
		return (
			<div><table id="tagSearchTbl" className="display compact" width="100%"></table></div>
		)
	}
}


export default TagSearchTbl;